import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-ssdf-call-dashboard-others',
  templateUrl: './ssdf-call-dashboard-others.component.html',
  styleUrls: ['./ssdf-call-dashboard-others.component.scss']
})
export class SsdfCallDashboardOthersComponent implements OnInit {
  @Input() originationData: any;
  @Input() appForTrl: any;
  @Input() appForRegion: any;
  @Input() formedCompanyData: any;
  @Input() zoneData: any;
  @Input() labNeededData: any;
  @Input() patentsData: any;
  @Input() fundingNeedPieData: any;
  @Input() countryData: any;

  @Input() applicationList : any[];
  constructor() { }

  ngOnInit(): void {
  }

}
